import { useServicos } from '@/api/queries/servicos';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';

const categoriaLabel: Record<string, string> = {
  diagnostico: 'Diagnóstico',
  site: 'Site',
  ads: 'Ads',
  conteudo: 'Conteúdo',
  mensalidade_mecanismo: 'Mensalidade',
  especifico: 'Específico',
};

export function ServicosPage() {
  const { data, isLoading } = useServicos();
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">
          Serviços <span className="text-base text-muted-foreground">({data?.length ?? 0})</span>
        </h1>
      </div>

      {isLoading ? (
        <Skeleton className="h-64" />
      ) : !data || data.length === 0 ? (
        <p className="text-muted-foreground">Sem serviços cadastrados.</p>
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {data.map((s) => (
            <Card key={s.id} className="p-4 space-y-2">
              <div className="flex items-start justify-between gap-2">
                <div>
                  <h3 className="font-medium">{s.nome}</h3>
                  <p className="text-xs text-muted-foreground">{s.slug}</p>
                </div>
                <Badge variant="outline">{categoriaLabel[s.categoria] ?? s.categoria}</Badge>
              </div>
              {s.descricao_curta && <p className="text-sm">{s.descricao_curta}</p>}
              {s.descricao_longa && (
                <p className="text-xs text-muted-foreground whitespace-pre-wrap">
                  {s.descricao_longa}
                </p>
              )}
              {(s.ticket_minimo_brl !== undefined || s.ticket_tipico_brl !== undefined) && (
                <div className="text-xs text-muted-foreground">
                  {s.ticket_minimo_brl !== undefined && (
                    <span>
                      mín R$ {Number(s.ticket_minimo_brl).toLocaleString('pt-BR')}
                    </span>
                  )}
                  {s.ticket_minimo_brl !== undefined && s.ticket_tipico_brl !== undefined && ' · '}
                  {s.ticket_tipico_brl !== undefined && (
                    <span>
                      típico R$ {Number(s.ticket_tipico_brl).toLocaleString('pt-BR')}
                    </span>
                  )}
                </div>
              )}
              {s.sinais_de_fit && s.sinais_de_fit.length > 0 && (
                <div className="flex flex-wrap gap-1 pt-1">
                  {s.sinais_de_fit.map((f) => (
                    <Badge key={f} variant="secondary" className="text-xs">
                      {f}
                    </Badge>
                  ))}
                </div>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
